import axios, { AxiosInstance } from 'axios';

const api: AxiosInstance = axios.create({
    baseURL: process.env.NEXT_PUBLIC_BACKEND_API_URL,
});

console.log('Configured API URL: ', process.env.NEXT_PUBLIC_BACKEND_API_URL);

export const detectBiasAPI = async (data: any) => {
    try {
        const response = await api.post('/api/v1/bias/detect', data);
        return response.data;
    } catch (error) {
        throw new Error('Failed to detectBiasAPI');
    }
};

export const explainBiasAPI = async (data: any) => {
    try {
        const response = await api.post('/api/v1/xai/explain', data);
        return response.data;
    } catch (error) {
        throw new Error('Failed to explainBiasAPI');
    }
};

export const visualizeBiasBertAPI = async (data: any) => {
    try {
        const response = await api.post('/api/v1/xai/bert-visualization', data);
        return response.data;
    } catch (error) {
        throw new Error('Failed to visualizeBiasBertAPI');
    }
};

export const visualizeBiasBertPredictionAPI = async (data: any) => {
    try {
        const response = await api.post(
            '/api/v1/xai/prediction-visualization',
            data
        );
        return response.data;
    } catch (error) {
        throw new Error('Failed to visualizeBiasBertPredictionAPI');
    }
};

export const chatWithAssistant = async (data: any) => {
    try {
        const response = await api.post('/api/v1/xai/chat', data);
        return response.data;
    } catch (error) {
        throw new Error('Failed to chatWithAssistant');
    }
};

export const compareBiasMethods = async (data: any) => {
    try {
        const response = await api.post('/api/v1/xai/compare', data);
        return response.data;
    } catch (error) {
        throw new Error('Failed to compareBiasMethods');
    }
};

export const fetchAnalysisHistory = async (limit: number = 10) => {
    try {
        const response = await api.get(`/api/v1/bias/history?limit=${limit}`);
        return response.data.analyses;
    } catch (error) {
        throw new Error('Failed to fetch analysis history');
    }
};

export const fetchAnalysisDetail = async (analysisId: number) => {
    try {
        const response = await api.get(`/api/v1/bias/history/${analysisId}`);
        return response.data;
    } catch (error) {
        throw new Error(`Failed to fetch analysis detail for ID ${analysisId}`);
    }
};
